// Regex for prohibited special characters
const SPECIAL_CHARS_REGEX = /[/*&^%$#@><+=\-_]/;
const SSI_SPECIAL_CHARS_REGEX = /[^a-zA-Z0-9-]/;

export const MAX_LENGTH = 35;

export function validateMaxLength(value, maxLength = MAX_LENGTH) {
  if (!value || typeof value !== 'string') {
    return true;
  }

  if (value.length > maxLength) {
    const errorMessage = `Please enter a value no longer than ${maxLength} characters.`;
    return errorMessage;
  }

  return true;
}

/**
 * Validates that the value does NOT contain defined special characters.
 * @param {string} value - The value to validate.
 * @returns {true|string} - true if valid, or an error message if not.
 */
export function validateNoSpecialChars(value) {
  if (typeof value !== 'string') {
    return true;
  }

  if (SPECIAL_CHARS_REGEX.test(value)) {
    const errorMessage =
      'Please remove any special character from this field to continue with your application (/*&^%$#@><+=-_)';
    return errorMessage;
  }

  return true;
}

/**
 * Validates that the value does NOT contain defined special characters.
 * @param {string} value - The value to validate.
 * @returns {true|string} - true if valid, or an error message if not.
 */
export function validateNoSpecialCharsForSSI(value) {
  if (typeof value !== 'string') return true;
  if (SSI_SPECIAL_CHARS_REGEX.test(value)) {
    return 'Please use only letters, numbers, and/or dashes (-).';
  }
  return true;
}

export const validateNoSpecialCharsAndMaxLength = (
  value,
  maxLength = MAX_LENGTH,
) => {
  // React Hook Form sometimes passes the form values object as the second parameter
  // We need to ensure we're using the correct maxLength value
  const actualMaxLength =
    typeof maxLength === 'number' ? maxLength : MAX_LENGTH;

  // First check for special characters
  const specialCharsResult = validateNoSpecialChars(value);

  if (specialCharsResult !== true) {
    return specialCharsResult;
  }

  // Then check for max length
  const maxLengthResult = validateMaxLength(value, actualMaxLength);

  if (maxLengthResult !== true) {
    return maxLengthResult;
  }

  return true;
};
